module.exports = __webpack_public_path__ + "imgs/linkedin.7e51e11488f9db8b23a718142d9ad34c.svg";